var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"counter"}},[_c('h1',[_vm._v("Counter")]),_c('p',[_vm._v("Current count: "+_vm._s(_vm.currentCount))]),_c('button',{on:{"click":_vm.IncrementCount}},[_vm._v("Click me")])])}
var staticRenderFns = []

export { render, staticRenderFns }